"use client";

// src/table.tsx
import { cn } from "@momo/utils";
import { jsx } from "react/jsx-runtime";
var Table = (props) => {
  const { className, ...rest } = props;
  return /* @__PURE__ */ jsx("div", { className: "relative w-full overflow-auto", children: /* @__PURE__ */ jsx("table", { className: cn("w-full caption-bottom text-sm", className), ...rest }) });
};
var TableHeader = (props) => {
  const { className, ...rest } = props;
  return /* @__PURE__ */ jsx("thead", { className: cn("[&_tr]:border-b", className), ...rest });
};
var TableBody = (props) => {
  const { className, ...rest } = props;
  return /* @__PURE__ */ jsx("tbody", { className: cn("[&_tr:last-child]:border-0", className), ...rest });
};
var TableFooter = (props) => {
  const { className, ...rest } = props;
  return /* @__PURE__ */ jsx(
    "tfoot",
    {
      className: cn("bg-muted/50 border-t font-medium [&>tr]:last:border-b-0", className),
      ...rest
    }
  );
};
var TableRow = (props) => {
  const { className, ...rest } = props;
  return /* @__PURE__ */ jsx(
    "tr",
    {
      className: cn(
        "border-b transition-colors",
        "hover:bg-muted/50",
        "data-[state=selected]:bg-muted",
        className
      ),
      ...rest
    }
  );
};
var TableHead = (props) => {
  const { className, ...rest } = props;
  return /* @__PURE__ */ jsx(
    "th",
    {
      className: cn(
        "text-muted-foreground h-12 px-4 text-left align-middle font-medium",
        "[&:has([role=checkbox])]:pr-0",
        className
      ),
      ...rest
    }
  );
};
var TableCell = (props) => {
  const { className, ...rest } = props;
  return /* @__PURE__ */ jsx("td", { className: cn("p-4 align-middle", "[&:has([role=checkbox])]:pr-0", className), ...rest });
};
var TableCaption = (props) => {
  const { className, ...rest } = props;
  return /* @__PURE__ */ jsx("caption", { className: cn("text-muted-foreground mt-4 text-sm", className), ...rest });
};

export {
  Table,
  TableHeader,
  TableBody,
  TableFooter,
  TableRow,
  TableHead,
  TableCell,
  TableCaption
};
